import { useEffect, useState } from "react";
import { promoActive } from "@/lib/promo";

/**
 * Ticking countdown to the promo end (promo.expires_at, end-of-day).
 * Returns { d, h, m, s } while the promo is live, otherwise null.
 */
export function usePromoCountdown(promo) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!promoActive(promo) || !promo?.expires_at) return null;
  const left = new Date(`${promo.expires_at}T23:59:59`).getTime() - now;
  if (left <= 0) return null;
  return {
    d: Math.floor(left / 86400000),
    h: Math.floor(left / 3600000) % 24,
    m: Math.floor(left / 60000) % 60,
    s: Math.floor(left / 1000) % 60,
  };
}

export const pad2 = (n) => String(n).padStart(2, "0");
